export const loadingStyles = {
  main: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  // puff: {
  //   color: "#21B8F9",
  //   height: 500,
  //   width: 100,
  // },
};
